export default {
      id: "iselect-smart-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#iselect-smart",
      toString: function () {
        return this.url;
      }
    }